import * as actionTypes from "../actions/actionTypes";

const INITIAL_STATE = {
  isAuthenticated: false,
  loginLoading: false,
  loginError: null,
  loading:false,
  logoutLoading: false,
  logoutError: null,
  logoLoading: false,
  logoError: null,
  logoData:[]


};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_REQUEST:
      return { ...state, loading: true,loginLoading:true };

    case actionTypes.LOGIN_SUCCESS:
      localStorage.setItem("access_token", action.payload.access_token);
      localStorage.setItem("refresh_token", action.payload.refresh_token);
      return {
        ...state,
        loading: false,
        loginLoading:false,
        isAuthenticated: true,
        loginError: null,
      };

    case actionTypes.LOGIN_FAILURE:
      return { ...state, loading: false,   loginLoading:false, loginError: action.error };

      case actionTypes.LOGO_REQUEST:
        return { ...state, logoLoading:true,logoData:[] };
  
      case actionTypes.LOGO_SUCCESS:
        return {
          ...state,
          logoLoading:false,
          logoData:action.payload,
          loginError: null,
        };
  
      case actionTypes.LOGO_FAILURE:
        return { ...state, logoLoading:false, logoError: action.error };
  

    case actionTypes.CLEAR_LOGIN_ERROR:
      return { ...state, loginError: null };
        
    case actionTypes.LOGOUT_REQUEST:
      return { ...state, logoutLoading: true };

    case actionTypes.LOGOUT_SUCCESS:
      localStorage.clear();
      return { ...state, logoutLoading: false, isAuthenticated: false };

    case actionTypes.LOGOUT_FAILURE:
      return { ...state, logoutError: action.error, logoutLoading: false };

    case actionTypes.FORCE_LOGOUT:
      localStorage.clear();
      return { ...state, logoutLoading: false, isAuthenticated: false };

    case actionTypes.FORGOT_REQUEST:
        return { ...state, loading: true };

    case actionTypes.FORGOT_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        loginError: null,
      };
    case actionTypes.FORGOT_FAILURE:
        return { ...state, loading: false, loginError: action.error };

    case actionTypes.RESET_REQUEST:
          return { ...state, loading: true };
  
    case actionTypes.RESET_SUCCESS:
        return {
          ...state,
          loading: false,
          isAuthenticated: false,
          loginError: null,
        };
    case actionTypes.RESET_FAILURE:
          return { ...state, loading: false, loginError: action.error };
    default:
      return state;
  }
};
